import { CSSProperties } from "react";
import styles from "./Loader.module.scss";

export function Loader({ baseColor }: { baseColor?: string }) {
  const browser = navigator.userAgent.toLowerCase();
  const isSafari = browser.indexOf("safari") !== -1 && browser.indexOf("chrome") === -1;

  const style = {
    "--base-color": baseColor || "white"
  } as CSSProperties;

  if (isSafari) {
    return <div className={styles.safariLoader} style={style} />;
  }

  return <div className={styles.loader} style={style} />;
}
